import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import ViolationCompare from "./Charts/ViolationCompare";
import SystemIcon from "../assets/images/system.png";
import UserIcon from "../assets/images/users.png";
import { Dropdown } from "primereact/dropdown";
import PPEChart from "./Charts/PPEChart";
import ViolationTrend from "./Charts/ViolationTrend";
import DateRangeFilter from "./common/DateRangeFilter";
import Persons2 from "./ImageSlider/Persons2";
import ViolationModal from "./Modals/ViolationModal";
import ViolationModal2 from "./Modals/ViolationModal2";
import AreaWise from "./Charts/AreaWise";
import apiClient from "../apiClient/apiClient";
import {
  AREA_VIOLATION,
  VIOLATION_GRAPH_URL,
  VIOLATION_RECENT_IMAGE_URL,
  VIOLATION_RECENT_IMAGE_URL_NEW,
  VIOLATION_STATS_URL,
  VIOLATION_TREND_URL,
} from "../apiClient/apiEndpoints";
import { getNameInitials, toTitleCase } from "../utils/common";
import { useSelector } from "react-redux";

const MainDashboard = () => {
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.user);
  const configData = useSelector((state) => state.config);
  const [photosModal, setPhotosModal] = useState(false);
  const [selectedTool, setSelectedTool] = useState();
  const [dates, setDates] = useState({ start: null, end: null });
  const [recentViolationImages, setRecentViolationImages] = useState([]);
  const [violationGraphStats, setViolationGraphStats] = useState();
  const [areaViolation, setAreaViolation] = useState([])
  const [violationTrends, setViolationTrends] = useState([]);
  const [stats, setStats] = useState({});
  const [toolOptions, setToolOptions] = useState([]);
  const [toolWiseViolations, setToolWiseViolations] = useState({})
  const API_URL = configData?.config?.API_URL;

  const fetchViolationStats = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_STATS_URL}`, { params });
    setStats(res);
  };

  const fetchViolationGraphStats = async () => {
    setLoading(true);
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_GRAPH_URL}`, { params });
    setViolationGraphStats(res);
    const toolData = Object.entries(res?.violation || {})?.map((item) => {
      return { name: toTitleCase(item[0]), value: item[0],  };
    });
    setToolWiseViolations(res?.violation)
    setToolOptions(toolData || []);
    setSelectedTool(toolData[0]?.value);
    setLoading(false);
  };

  // const fetchRecentViolationImages = async () => {
  //   const params = {};
  //   if (dates?.start && dates?.end) {
  //     params.start = dates.start.toISOString();
  //     params.end = dates.end.toISOString();
  //   }
  //   const res = await apiClient.get(`${API_URL}${VIOLATION_RECENT_IMAGE_URL}`, { params });
  //   setRecentViolationImages(res);
  // };
  const fetchRecentViolationImages = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const response= await apiClient.get(`${API_URL}${VIOLATION_RECENT_IMAGE_URL_NEW}`, { params });
    setRecentViolationImages(response);
  };

  const fetchViolationTrends = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${VIOLATION_TREND_URL}`, { params });
    setViolationTrends(res);
  };

  const fetchViolationPerArea = async () => {
    const params = {};
    if (dates?.start && dates?.end) {
      params.start = dates.start.toISOString();
      params.end = dates.end.toISOString();
    }
    const res = await apiClient.get(`${API_URL}${AREA_VIOLATION}`, { params });
    setAreaViolation(res)
  };

  useEffect(() => {
    fetchRecentViolationImages();
    // fetchViolationGraphStats();
    // fetchViolationStats();
    // fetchViolationTrends();
    // fetchViolationPerArea()
  }, [dates?.start, dates?.end]);
  console.log(recentViolationImages)
  return (
    <>
      <div className="container-fluid admindashboard p-4 pt-2 bg-grey-main">
        <div className="row align-items-center mt-0 mb-2">
          <div className="col-lg-6"></div>
          <div className="col-lg-6 d-flex align-items-center justify-content-end gap-4">
            <DateRangeFilter dates={dates} setDates={setDates} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 pe-2">
            <div className="userdash">
              <div className="card cardesign welcomecard">
                <div className="card-block d-flex align-items-center">
                  {loading ? (
                    <Skeleton width="70px" height="70px" circle baseColor="#ebebeb" highlightColor="#ffffff" />
                  ) : (
                    <>
                      <div className="profile-img">
                        {userData?.user?.avatar ? (
                          <img src={userData?.user?.avatar} alt="" referrerPolicy="no-referrer" />
                        ) : (
                          <div className="initials-placeholder">{getNameInitials(userData?.user?.name)}</div>
                        )}
                      </div>
                    </>
                  )}
                  <div className="welcomediv ps-3">
                    <h6 className="m-0 p-0">
                      {loading ? (
                        <Skeleton width="15rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                      ) : (
                        <>{userData?.user?.name}</>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 ps-2">
          <div className="stat-box h-100 p-0" style={{ width:"140%" }}>
              <ViolationCompare violationCount={stats?.violation} nonViolationCount={stats?.nonViolation} />
              <div className="d-flex flex-column double-data gap-2">
                <span>
                  <h6 className="mt-0">People with Violation :</h6>
                  <div className="d-flex gap-2">
                    <h1>{stats?.violation ?? 0}</h1>
                  </div>
                </span>
                <span>
                  <h6 className="mt-0">People with Non Violation :</h6>
                  <div className="d-flex gap-2">
                    <h1>{stats?.nonViolation ?? 0}</h1>
                  </div>
                </span>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6 ps-2">
            <div className="userdash">
              <div className="redgreen">
                <span>
                  <h6 style={{ color: "#333333" }}>Black</h6>
                  <p>Safe to Operate</p>
                </span>
                <span>
                  <h6>Red</h6>
                  <p>Caution, Trigger Action</p>
                </span>
              </div>
            </div>
          </div> */}
        </div>
        {/* <div className="row">
          <div className="stats-parent">
            <div className="stat-box h-100 p-0" style={{ width:"140%" }}>
              <ViolationCompare violationCount={stats?.violation} nonViolationCount={stats?.nonViolation} />
              <div className="d-flex flex-column double-data gap-2">
                <span>
                  <h6 className="mt-0">People with Violation :</h6>
                  <div className="d-flex gap-2">
                    <h1>{stats?.violation ?? 0}</h1>
                  </div>
                </span>
                <span>
                  <h6 className="mt-0">People with Non Violation :</h6>
                  <div className="d-flex gap-2">
                    <h1>{stats?.nonViolation ?? 0}</h1>
                  </div>
                </span>
              </div>
            </div>
            <div className="stat-box h-100">
              <span className="icon-parent">
                <img src={SystemIcon} alt="{item.tag}" />
              </span>
              <div className="d-flex flex-column">
                <div className="flex justify-content-center prime-select">
                  <Dropdown
                    value={selectedTool}
                    onChange={(e) => setSelectedTool(e?.value)}
                    options={toolOptions}
                    optionLabel="name"
                    placeholder="Select Prop"
                    select
                    className="w-full md:w-14rem"
                  />
                </div>
                <div className="d-flex gap-2">
                  <h1>{toolWiseViolations[selectedTool]}</h1>
                </div>
              </div>
            </div>
            <div className="stat-box h-100">
              <span className="icon-parent">
                <img src={UserIcon} alt="{item.tag}" />
              </span>
              <div className="d-flex flex-column">
                <h6 className="mt-0">Person Detected</h6>
                <div className="d-flex gap-2">
                  <h1>{stats?.totalDetections ?? 0}</h1>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="row">
          <div className="col-lg-6 pe-2">
            <div className="cardbox overflow-hidden custom-chart mt-3">
              <h5 className="mb-0">
                {loading ? (
                  <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                ) : (
                  "PPE Detection"
                )}
              </h5>
              <PPEChart statsData={violationGraphStats} />
            </div>
          </div>
          <div className="col-lg-6 ps-2">
            <div className="cardbox overflow-hidden custom-chart mt-3">
              <h5 className="mb-0">
                {loading ? (
                  <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                ) : (
                  "Violation Trend"
                )}
              </h5>
              <ViolationTrend data={violationTrends} />
            </div>
          </div>
        </div> */}
        <div className="row">
          <div className="col-lg-6 pe-2">
            <div className="cardbox overflow-hidden custom-chart mt-3 image-slider">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0">
                  {loading ? (
                    <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                  ) : (
                    "Violation Incidents"
                  )}
                </h5>
                {recentViolationImages.length > 0 && (
                  <span className="showmore" onClick={() => setPhotosModal(true)}>
                    View more &gt;
                  </span>
                )}
              </div>
              <Persons2 images={recentViolationImages?.slice(0, 5)} />
            </div>
          </div>
          {/* <div className="col-lg-6 ps-2">
            <div className="cardbox overflow-hidden custom-chart mt-3">
              <h5 className="mb-0">
                {loading ? (
                  <Skeleton width="15rem" height="1.4rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                ) : (
                  "Area Wise Violation"
                )}
              </h5>
              <AreaWise data={areaViolation}/>
            </div>
          </div> */}
        </div>
      </div>

      {/* <ViolationModal images={recentViolationImages} photosModal={photosModal} setPhotosModal={setPhotosModal} loading={loading} /> */}
      <ViolationModal2 images={recentViolationImages} photosModal={photosModal} setPhotosModal={setPhotosModal} loading={loading} />
    </>
  );
};

export default MainDashboard;
